module.exports = __webpack_public_path__ + "static/cheapest-price-sourcing-e9cf42e7da7ed3606fab8b89bb167c2c.png";